<template>
    <div>
        <div class="is-pulled-right" style="display:none">
            <div class="button " :class="{'is-success' : include_archived == 1}" @click="toggleIncludeArchived">Include Archived</div>
        </div>
        
        
        

        <p class="heading mb-1"><strong>Grades</strong></p>
        <div class="buttons mb-3">
            <div class="button is-small" v-for="(grade, key) in grades.filter(g => g.doctor != 1)" :disabled="working==true" :id="grade.id" :key="key" :class="{ 'is-success': selected_grades.includes(grade.id) }" @click="toggleButton(grade.id)">{{ grade.name }}</div>
        </div>

        <p class="heading mb-1"><strong>Doctor Grades</strong></p>
        <div class="buttons mb-3">
            <div class="button is-small" v-for="(grade, key) in grades.filter(g => g.doctor == 1)" :disabled="working==true" :id="grade.id" :key="key" :class="{ 'is-success': selected_grades.includes(grade.id) }" @click="toggleButton(grade.id)">{{ grade.name }}</div>
        </div>

        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && currentMonthMembers.length == 0 && previousMonthMembers.length == 0">
            No members can be found matching your search criteria
        </div>

        <h4 class="title is-size-4">Cleared Members ({{ currentMonthMembers.length + previousMonthMembers.length }})</h4>

        <div class="columns" v-if="loading == false">
            <div class="column">
                <h5 class="title is-size-5">{{ currentMonthLabel }} ({{ currentMonthMembers.length }})</h5>
                <ul v-if="currentMonthMembers.length > 0">
                    <li v-for="row in currentMonthMembers" :key="'current-' + row.id" class="mb-1">
                        <router-link :to="'/members/' + row.id" target="_blank">{{ row.forename }} {{ row.surname }}</router-link>
                        <span v-if="row.nationality_name"> - {{ row.nationality_name }}</span>
                    </li>
                </ul>
                <p v-else>No members cleared in {{ currentMonthLabel }}.</p>
            </div>

            <div class="column">
                <h5 class="title is-size-5">{{ previousMonthLabel }} ({{ previousMonthMembers.length }})</h5>
                <ul v-if="previousMonthMembers.length > 0">
                    <li v-for="row in previousMonthMembers" :key="'previous-' + row.id" class="mb-1">
                        <router-link :to="'/members/' + row.id" target="_blank">{{ row.forename }} {{ row.surname }}</router-link>
                        <span v-if="row.nationality_name"> - {{ row.nationality_name }}</span>
                    </li>
                </ul>
                <p v-else>No members cleared in {{ previousMonthLabel }}.</p>
            </div>
        </div>

        

       
    </div>
</template>

<script>
import * as XLSX from 'xlsx'

//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'MembersByGrade',
        mixins: [MemberMixin],
        data: function () {
            return {
                member_search: '',
                   members: [],
                   loading: false,
                   searchPerformed: false,
                   showModal: false,
                   order_by: 'surname ASC, forename ASC',
                   accessToken: '',
                   include_archived: 0,
                   grades: [],
                   selected_grades: [],
                   working:false
            }
        },
        methods: {
            exportXLS() {
		
                var wb = XLSX.utils.table_to_book(document.getElementById('memberstable'), {sheet:"Sheet JS"});
                XLSX.writeFile(wb, 'Members_Mail_Merge.xlsx')

            },
            toggleButton(buttonId) {
                this.working = true;
                const index = this.selected_grades.indexOf(buttonId);
                if (index === -1) {
                    // Button not selected, add it to the selectedButtons array
                    this.selected_grades.push(buttonId);
                } else {
                    // Button already selected, remove it from the selectedButtons array
                    this.selected_grades.splice(index, 1);
                }
                this.getMembers(this.order_by, '', this.selected_grades, 0, 1);
            },
            toggleIncludeArchived()
            {
                if(this.include_archived == 1)
                {
                    this.include_archived = 0
                }
                else{
                    this.include_archived = 1
                }
                this.getMembers(this.order_by, this.include_archived, "", 0, 1);
            },
            resetForm()
            {
                this.member_search = '';
                localStorage.member_search = '';
                this.searchPerformed = false
                this.members = [];

                this.$refs.member_search.focus();
            },
            searchMembers()
            {
                //localStorage.member_search = this.member_search;
                //this.getMembers(this.order_by, this.include_archived);
            },
            parseMemberApprovedDate(value) {
                if (!value) {
                    return null;
                }

                const parts = value.split('-');
                if (parts.length < 3) {
                    return null;
                }

                const year = Number(parts[0]);
                const month = Number(parts[1]);
                const day = Number(parts[2]);

                if (!year || !month || !day) {
                    return null;
                }

                return new Date(year, month - 1, day);
            },
            isApprovedInMonth(approvedDate, monthOffset) {
                const date = this.parseMemberApprovedDate(approvedDate);
                if (!date) {
                    return false;
                }

                const today = new Date();
                const targetMonth = new Date(today.getFullYear(), today.getMonth() + monthOffset, 1);
                return date.getFullYear() === targetMonth.getFullYear() && date.getMonth() === targetMonth.getMonth();
            }
            
        },
        created() {
            this.getAccessToken()
                .then(() => { 
                    this.getGrades();
                });
        
        },
        mounted() {
            
        },
        computed: {
            combinedEmails() {
            return this.members.map(member => member.email).join('; ');
            },
            currentMonthLabel() {
                const today = new Date();
                return today.toLocaleString('en-GB', { month: 'long', year: 'numeric' });
            },
            previousMonthLabel() {
                const previousMonthDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
                return previousMonthDate.toLocaleString('en-GB', { month: 'long', year: 'numeric' });
            },
            currentMonthMembers() {
                return this.members.filter(member => this.isApprovedInMonth(member.approved_date, 0));
            },
            previousMonthMembers() {
                return this.members.filter(member => this.isApprovedInMonth(member.approved_date, -1));
            }
        },
        watch: {
            grades(newGrades) {
                if (!Array.isArray(newGrades) || newGrades.length === 0) {
                    return;
                }

                // Select every grade by default on first load.
                if (this.selected_grades.length === 0) {
                    this.selected_grades = newGrades.map(grade => grade.id);
                    this.getMembers(this.order_by, '', this.selected_grades, 0, 1);
                }
            }
        }
       
    }
</script>